export const ROUTES = Object.freeze({
  home: '/',
  identify: '/identify',
  knowledge: '/knowledge',
  taxa: '/taxa',
  characters: '/characters',
  sources: '/sources',
  review: '/review',
  quercusReview: '/review/quercus-characters',
  guidedPrototype: '/identify-test',
  setup: '/setup',
})

export const REPOSITORY_CONTEXT = Object.freeze({
  packVersion: '0.6.0-basic-test-library-batch2-proposed',
  knowledgeStatus: 'Proposed',
  liveDatabase: 'Supabase · botanical',
  installedRelease: 'Not recorded',
  runtimeStatus: 'Not connected',
})

export const WORKSPACE_GROUPS = Object.freeze([
  {
    id: 'identify', label: 'Identify', description: 'Field identification',
    items: [{ to: ROUTES.identify, label: 'Identify', icon: 'search', end: true, status: 'Unavailable' }],
  },
  {
    id: 'knowledge', label: 'Knowledge', description: 'Installed reference data',
    items: [
      { to: ROUTES.knowledge, label: 'Database overview', icon: 'dashboard', end: true },
      { to: ROUTES.taxa, label: 'Taxa', icon: 'flower' },
      { to: ROUTES.characters, label: 'Characters', icon: 'shapes' },
      { to: ROUTES.sources, label: 'Sources', icon: 'book' },
    ],
  },
  {
    id: 'review', label: 'Review', description: 'Scientific governance',
    items: [
      { to: ROUTES.review, label: 'Proposed Records', icon: 'inbox', end: true },
      { to: ROUTES.quercusReview, label: 'Quercus Campaign', icon: 'leaf', end: true },
    ],
  },
  {
    id: 'testing', label: 'Testing', description: 'Internal evaluation',
    items: [{ to: ROUTES.guidedPrototype, label: 'Guided Observation', icon: 'flask', badge: 'Prototype', end: true, synthetic: true }],
  },
  {
    id: 'administration', label: 'Administration', description: 'Configuration', deEmphasized: true,
    items: [{ to: ROUTES.setup, label: 'Setup', icon: 'settings', end: true }],
  },
])

export function workspaceForPath(pathname) {
  if (pathname === ROUTES.home) return { id: 'home', label: 'Workspace home' }
  return WORKSPACE_GROUPS.find((group) => group.items.some((item) => (
    item.end ? pathname === item.to : pathname === item.to || pathname.startsWith(`${item.to}/`)
  ))) || { id: 'home', label: 'Botanical Field Assistant' }
}
